"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var saveReadingPaneOption_1 = require("./actions/saveReadingPaneOption");
exports.saveReadingPaneOptionQuick = saveReadingPaneOption_1.saveReadingPaneOptionQuick;
//# sourceMappingURL=lazyIndex.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-reading-pane-option/lib/lazyIndex.js
// module id = 1891
// module chunks = 2